export default {
  Summary: "Summary",
  CFA: "CFA",
  Documents: "Documents",
  Settings: "Supplier Settings",
  Signatories: "Signatories",
};
